const o = void 0;

export { o as EMPTY_OPTION_VALUE };
//# sourceMappingURL=index.js.map
